<template>
    <div class="ContactUs-box">
        <menuBox :step="3"></menuBox>
        <div class="contact-us-bg">
            <div> liên hệ chúng tôi</div>
            <p>100 khách hàng hài lòng là mục tiêu phục vụ của chúng tôi.</p>
            <p>Tiêu chuẩn dịch vụ của chúng tôi là thực hiện 100% tận tâm.</p>
            <p>Khách hàng luôn đến trước là nguyên lý dịch vụ của chúng tôi.</p>
        </div>

        <div class="msg-box">
            <div class="send-msg">
                <div class="titmsg">Gửi email cho chúng tôi</div>
                <div class="input-box">
                    <input type="text" placeholder="tên" class="input-text" v-model="name">
                    <input type="text" placeholder="Thư " class="input-text" v-model="email">
                </div>
                <textarea name="" id="" cols="30" rows="10" placeholder="thông tin" class="textarea-text" v-model="textarea"></textarea>
                <div class="send" @click="SubmitOk">gửi email</div>
            </div>
            <div class="msg-info">
                <div class="info-title">liên hệ chúng tôi</div>
                <div class="text-2">Chúng tôi chân thành chào đón sự tư vấn của bạn và tạo ra một gia đình ấm áp với chúng tôi</div>
                <div class="info-item">
                    <img src="../assets/contact-2.png" alt="">
                    <div class="text-3">
                        <div>Địa chỉ:</div>
                        <p>4151445</p>
                    </div>
                </div>
                <div class="info-item">
                    <img src="../assets/contact-2.png" alt="">
                    <div class="text-3">
                        <div>Điện thoại:</div>
                        <p>4151445</p>
                    </div>
                </div>
            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            name: '',
            email: '',
            textarea: '',
        }
    },
    mounted() {

    },
    methods: {
        SubmitOk() {
            if (!this.name) {
                return alert('xin hãy nhập tên của bạn')
            } else if (!this.email) {
                return alert('Vui lòng nhập email')
            } else if (!this.textarea) {
                return alert('Vui lòng nhập tin nhắn của bạn')
            }
            alert('gửi thành công')
        }
    }
}
</script>
<style lang="less" scoped>
.title {
    font-weight: 600;
    font-size: 48px;
    color: #0E235F;
    text-align: center;
}

.sbtitle {
    font-size: 18px;
    color: #0E235F;
    margin-top: 17px;
    text-align: center;
}

.contact-us-bg {
    height: 320px;
    background: url(../assets/contact-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div {
        font-weight: bold;
        font-size: 40px;
        color: #FFFFFF;
    }

    p {
        font-size: 14px;
        color: #FFFFFF;
        margin-top: 5px;
    }
}

.msg-box {
    padding: 100px 360px;
    display: flex;
    align-items: self-start;
    justify-content: space-between;

    .send-msg {
        padding: 52px 44px;
        background: #FFFFFF;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
        width: 686px;
        min-height: 250px;

        .titmsg {
            font-weight: bold;
            font-size: 26px;
            color: #0E235F;
        }

        .input-box {
            margin-top: 34px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .input-text {
                width: 288px;
                height: 60px;
                background: #F9F9F9;
                border: 1px solid #D6D6D6;
                padding: 0px 20px;
            }
        }

        .textarea-text {
            width: 646px;
            height: 110px;
            background: #F9F9F9;
            border: 1px solid #D6D6D6;
            margin-top: 30px;
            padding: 20px;
        }

        .send {
            width: 166px;
            height: 50px;
            background: #3568FE;
            margin-top: 40px;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
        }
    }

    .msg-info {
        background: #FFFFFF;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
        padding: 52px 30px;
        width: 310px;
        min-height: 250px;

        .info-title {
            font-weight: bold;
            font-size: 26px;
            color: #0E235F;
        }

        .text-2 {
            font-size: 16px;
            color: #0E235F;
            margin-top: 10px;
        }

        .info-item {
            display: flex;
            align-items: flex-start;
            margin-top: 73px;

            img {
                width: 52px;
                margin-right: 10px;
            }

            .text-3 {
                div {
                    font-weight: normal;
                    font-size: 18px;
                    color: #0E235F;
                }

                p {
                    margin-top: 5px;
                    font-size: 16px;
                    color: #0E235F;
                }
            }
        }
    }
}
</style>
